import ProgressBar from 'components/ProgressBar';
import React from 'react';
import classNames from 'classnames';

interface StatCardProps {
  label: string;
  value: string | JSX.Element;
  children?: React.ReactNode;
}
const StatCard = ({ label, value, children }: StatCardProps) => (
  <SharedCardStructure label={label} value={value}>
    {children}
  </SharedCardStructure>
);

export const StatCardWithProgress = ({
  label,
  value,
  progress
}: {
  label: string;
  value: string;
  progress: { value: number; max: number };
}) => (
  <SharedCardStructure label={label} value={value}>
    {progress && <ProgressBar value={progress.value} max={progress.max} />}
  </SharedCardStructure>
);
const SharedCardStructure = ({
  label,
  value,
  children
}: {
  label: string;
  value: string | JSX.Element;
  children?: React.ReactNode;
}) => (
  <div className="flex flex-row rounded-lg border border-neutral-90 p-4 min-w-[250px] items-center gap-8">
    <div className="flex flex-col">
      <span className="text-sm font-bold text-gray-500 whitespace-nowrap">
        {label}
      </span>
      <div className="flex flex-row">
        {typeof value === 'string' ? (
          <span className="text-lg font-bold text-gray-600">{value}</span>
        ) : (
          value
        )}
      </div>
    </div>
    {children}
  </div>
);
interface Stat {
  label: string;
  value: string | number;
}

interface MultiStatCardProps {
  title: string;
  stats: Stat[];
  className?: string;
  iconUrl?: string;
  onClick?: () => void;
}
export const MultiStatCard = ({
  title,
  stats,
  className,
  iconUrl,
  onClick
}: MultiStatCardProps) => (
  <div
    className={classNames(
      'flex flex-col rounded-lg border border-neutral-90 p-4 min-w-[250px]',
      className,
      {
        'cursor-pointer': onClick
      }
    )}
    onClick={onClick}
  >
    <div className="flex items-center mb-2">
      <img src={iconUrl} alt="campaign" className="mr-2" />
      <span className="text-sm font-bold text-gray-500">{title}</span>
    </div>
    <div className="flex flex-row justify-between">
      {stats.map((stat) => (
        <div key={`multi-stat-card-${stat.label}`} className="flex flex-col">
          <span className="text-sm text-gray-500">{stat.label}</span>
          <span className="text-lg font-bold text-gray-600">{stat.value}</span>
        </div>
      ))}
    </div>
  </div>
);
export default StatCard;
